/**
 * @license lucide v0.294.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */

import defaultAttributes from '../defaultAttributes.js';

const Navigation = [
  "svg",
  defaultAttributes,
  [["polygon", { points: "3 11 22 2 13 21 11 13 3 11" }]]
];

export { Navigation as default };
//# sourceMappingURL=navigation.js.map
